<template>
  <div
    v-if="effectiveBanners?.length"
    class="catalog-banners"
  >
    <ul
      class="catalog-banners__list"
      :style="`--columns: ${effectiveBanners.length};`"
    >
      <li
        v-for="banner in effectiveBanners?.slice(0, 1)"
        :key="banner"
        class="catalog-banners__item"
      >
        <StrapiBanner
          :banner="banner"
          class="catalog-banners__banner"
          :lazy="false"
          :banner-count="effectiveBanners?.length"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  banners: any[]
}>()

const { data: genericPlpBannerResponse } = await useAsyncGraphqlQuery('genericPlpBanner', {
  status: 'PUBLISHED',
}, useGraphqlDefaultClient())

const effectiveBanners = computed(() => {
  const generic = genericPlpBannerResponse.value?.data?.genericPlpBanner
  if (generic?.Active === true && generic?.Banner) {
    return [generic.Banner]
  }
  return props.banners
})
</script>

<style src="~layers/app/components/Catalog/Banners.css" />
